// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerFile_root__1vL3G"};